import { TermModalProps } from './types/term';
import DialogModal from '../../components/DialogModal';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { StyledButton } from '../Exams/styled';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import terms from '../../apis/terms';

const EditTermModal: React.FC<TermModalProps> = ({
  fetchData,
  open,
  onClose,
  term,
  onApiSuccessAndFailure
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState<string>('');

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  useEffect(() => {
    if (term) {
      setName(term.name);
    }
  }, [term]);

  const handleSubmit = async () => {
    if (isSubmitting || !term?.id) return;

    setIsSubmitting(true);
    const payload = { name, id: term.id };

    try {
      const response = await terms.upsertTerm(loggedInUser.school, payload);
      if (response) {
        fetchData();
        const message = `Term updated successfully`;
        onApiSuccessAndFailure(true, message);
      }
    } catch (error) {
      const message = `Term with the same name already exists`;
      onApiSuccessAndFailure(false, message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setName(term?.name || '');
    onClose();
  };

  return (
    <>
      <DialogModal
        open={open}
        onClose={handleClose}
        title='Edit Term'
        actions={
          <>
            <Button onClick={handleClose} color='primary'>
              Cancel
            </Button>
            <StyledButton
              onClick={handleSubmit}
              disabled={isSubmitting || !name.trim() || name === term?.name}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Update'
              )}
            </StyledButton>
          </>
        }
      >
        <Box>
          <TextField
            fullWidth
            id='name'
            name='name'
            label='Term Name'
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            required
            placeholder='Enter term name'
          />
        </Box>
      </DialogModal>
    </>
  );
};

export default EditTermModal;
